import { useState, useEffect, useCallback } from "react";
import { useAuthenticatedFetch } from "./useAuthenticatedFetch";

interface EmbedStatus {
  enabled: boolean;
  blockType: string | null;
}

export function useEmbedStatus() {
  const authFetch = useAuthenticatedFetch();
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authFetch("/api/admin/theme/embed-status");

      if (!response.ok) {
        throw new Error(`Failed to fetch embed status: ${response.status}`);
      }

      const data: EmbedStatus = await response.json();
      setEnabled(data.enabled);
    } catch (error) {
      console.error("[CodWay] Error fetching embed status:", error);
      setEnabled(null);
    } finally {
      setLoading(false);
    }
  }, [authFetch]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { enabled, loading, refetch: fetchStatus };
}
